import { useEffect, useState } from 'react';
import { Button, Form, Modal } from 'react-bootstrap';
import PermissionsDropdown from '../PermissionsDropdown/PermissionsDropdown';
import SearchUserDropdown from '../SearchUserDropdown/SearchUserDropdown';

const AddGroupModal = ({ handleClose, show, onAdd }) => {
    const [groupName, setGroupName] = useState('');
    const [groupMembers, setGroupMembers] = useState([]);
    const [permissionTypes, setPermissionTypes] = useState('');
    const [createdBy, setCreatedBy] = useState('');

    useEffect(() => {
        setCreatedBy(localStorage.getItem('badgeID'));
    }, []);

    const getPermissionID = (permissionID) => {
        setPermissionTypes(permissionID);
    };

    const onSubmit = (e) => {
        e.preventDefault();

        if (!groupName) {
            alert('Please enter a group name');
        } else if (groupMembers.length === 0) {
            alert('Please select at least a member');
        } else if (permissionTypes.length === 0) {
            alert('Please select at least a permission setting');
        } else {
            const userID = groupMembers.map((item) => item.empId).toString();
            const userName = groupMembers
                .map((item) => item.formalName)
                .toString();
            const permission = permissionTypes.toString();

            onAdd({
                groupName,
                userID,
                userName,
                permission,
                createdBy,
            });
        }
    };

    return (
        <Modal show={show} onHide={handleClose}>
            <Modal.Header>
                <Modal.Title style={{ marginBottom: '0px' }}>
                    Create Permission Group
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Form onSubmit={onSubmit}>
                    <Form.Group className='mb-3'>
                        <Form.Label>Group Name</Form.Label>
                        <Form.Control
                            type='text'
                            placeholder='Insert your group name here...'
                            style={{ width: '100%' }}
                            value={groupName}
                            onChange={(e) => setGroupName(e.target.value)}
                        />
                    </Form.Group>
                    <Form.Group className='mb-3'>
                        <Form.Label>Group Members</Form.Label>
                        <SearchUserDropdown setGroupMembers={setGroupMembers} />
                    </Form.Group>
                    <Form.Group className='mb-3'>
                        <Form.Label>Permission Settings</Form.Label>
                        <PermissionsDropdown
                            getPermissionID={getPermissionID}
                        />
                    </Form.Group>
                    <Button as='input' type='submit' value='Submit' />
                    <Button variant='outline-secondary' onClick={handleClose}>
                        Close
                    </Button>
                </Form>
            </Modal.Body>
        </Modal>
    );
};

export default AddGroupModal;
